webpackJsonp([42],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_sdg1.c1da66f.svg";

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Utility__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'About',
  data: function data() {
    return {
      width: '50%',
      top: '50%'
    };
  },

  props: ['closePopupCB'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['AppConfig'])),
  components: {
    Popup: function Popup() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 70));
    }
  },
  methods: {
    closePopup: function closePopup() {
      // Hide the popup
      this.closePopupCB();
    },
    open: function open(page) {
      if (!this.AppConfig) return;
      if (page == 'T') {
        window.open(this.AppConfig.about.tnc);
      } else if (page == 'P') {
        window.open(this.AppConfig.about.privacy);
      }
      // if (page === 'T') {
      //   this.$router.push({ name: 'TermsOfUse'})
      // } else {
      //   this.$router.push({ name: 'PrivacyPolicy'})
      // }
      // this.closePopup()
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Utility__["a" /* default */]]

});

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(325);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428e4508_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(409);
function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-428e4508"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428e4508_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("420292ba", content, true, {});

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".text-style[data-v-428e4508]{color:#212121;font-family:ProximanovaRegular;font-size:16px}.boldStyle[data-v-428e4508]{font-family:ProximanovaBold}.support-text[data-v-428e4508]{text-align:center}.about-container[data-v-428e4508]{padding:10%}.about-container .about-logo[data-v-428e4508]{text-align:center;padding-bottom:5%}.about-container .about-logo img[data-v-428e4508]{width:15%}.about-container .about-text[data-v-428e4508]{padding-bottom:5%}.about-container .about-links[data-v-428e4508],.about-container .about-text p[data-v-428e4508]{text-align:center}.about-container .about-links[data-v-428e4508] :first-child{margin-right:5%}.about-container .about-links span[data-v-428e4508]{color:#4558dd;font-family:ProximanovaRegular;font-size:14px;text-transform:uppercase;cursor:pointer}.about-container .about-links span[data-v-428e4508]:hover{text-decoration:underline}.about-container .about-social-icons[data-v-428e4508]{text-align:center;padding:5% 0}.about-container .about-social-icons p[data-v-428e4508]{padding:2%}.about-container .about-social-icons[data-v-428e4508] :nth-child(2){margin-left:0}.about-container .about-social-icons a[data-v-428e4508]{margin-left:20px;opacity:.8}.about-container .about-social-icons a[data-v-428e4508]:hover{opacity:1}.about-container .about-social-icons img[data-v-428e4508]{-webkit-box-flex:1;-ms-flex:1;flex:1;width:25px;height:25px;cursor:pointer}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Popups/About.vue"],"names":[],"mappings":"AACA,6BAA6B,cAAc,+BAAiC,cAAc,CACzF,AACD,4BAA4B,2BAA6B,CACxD,AACD,+BAA+B,iBAAiB,CAC/C,AACD,kCAAkC,WAAW,CAC5C,AACD,8CAA8C,kBAAkB,iBAAiB,CAChF,AACD,kDAAkD,SAAS,CAC1D,AACD,8CAA8C,iBAAiB,CAC9D,AAGD,+FAA+C,iBAAiB,CAC/D,AACD,4DAA6D,eAAe,CAC3E,AACD,oDAAoD,cAAc,+BAAiC,eAAe,yBAAyB,cAAc,CACxJ,AACD,0DAA0D,yBAAyB,CAClF,AACD,sDAAsD,kBAAkB,YAAY,CACnF,AACD,wDAAwD,UAAU,CACjE,AACD,oEAAoE,aAAe,CAClF,AACD,wDAAwD,iBAAiB,UAAW,CACnF,AACD,8DAA8D,SAAS,CACtE,AACD,0DAA0D,mBAAmB,WAAW,OAAO,WAAW,YAAY,cAAc,CACnI","file":"About.vue","sourcesContent":["\n.text-style[data-v-428e4508]{color:#212121;font-family:\"ProximanovaRegular\";font-size:16px\n}\n.boldStyle[data-v-428e4508]{font-family:\"ProximanovaBold\"\n}\n.support-text[data-v-428e4508]{text-align:center\n}\n.about-container[data-v-428e4508]{padding:10%\n}\n.about-container .about-logo[data-v-428e4508]{text-align:center;padding-bottom:5%\n}\n.about-container .about-logo img[data-v-428e4508]{width:15%\n}\n.about-container .about-text[data-v-428e4508]{padding-bottom:5%\n}\n.about-container .about-text p[data-v-428e4508]{text-align:center\n}\n.about-container .about-links[data-v-428e4508]{text-align:center\n}\n.about-container .about-links[data-v-428e4508] :nth-child(1){margin-right:5%\n}\n.about-container .about-links span[data-v-428e4508]{color:#4558DD;font-family:\"ProximanovaRegular\";font-size:14px;text-transform:uppercase;cursor:pointer\n}\n.about-container .about-links span[data-v-428e4508]:hover{text-decoration:underline\n}\n.about-container .about-social-icons[data-v-428e4508]{text-align:center;padding:5% 0\n}\n.about-container .about-social-icons p[data-v-428e4508]{padding:2%\n}\n.about-container .about-social-icons[data-v-428e4508] :nth-child(2){margin-left:0px\n}\n.about-container .about-social-icons a[data-v-428e4508]{margin-left:20px;opacity:0.8\n}\n.about-container .about-social-icons a[data-v-428e4508]:hover{opacity:1\n}\n.about-container .about-social-icons img[data-v-428e4508]{-webkit-box-flex:1;-ms-flex:1;flex:1;width:25px;height:25px;cursor:pointer\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"width":_vm.width,"top":_vm.top,"closePopupEvent":_vm.closePopupCB}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h6',{staticClass:"login-header"},[_vm._v("About")])]),_vm._v(" "),_c('div',{staticClass:"about-container"},[_c('div',{staticClass:"about-logo"},[_c('img',{attrs:{"src":__webpack_require__(202),"alt":"logo"}}),_vm._v(" "),_c('p',[_vm._v("1.0.0")])]),_vm._v(" "),_c('div',{staticClass:"about-text"},[_c('p',{staticClass:"text-style"},[_vm._v("\n          "+_vm._s(_vm.AppConfig.about.abouttext)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"support-text"},[_c('p',[_c('a',{staticClass:"text-style",attrs:{"href":_vm.AppConfig.about.website,"target":"_blank","rel":"noopener","aria-label":"Web link"}},[_vm._v("\n          "+_vm._s(_vm.AppConfig.about.website)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"about-social-icons"},[_c('p',{staticClass:"text-style boldStyle"},[_vm._v("Follow Us")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.facebook,"target":"_blank","rel":"noopener","aria-label":"facebook link"}},[_c('img',{attrs:{"src":__webpack_require__(40),"alt":"facebook logo"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.instagram,"target":"_blank","rel":"noopener","aria-label":"facebook link"}},[_c('img',{attrs:{"src":__webpack_require__(41),"alt":"instagram logo"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.twitter,"target":"_blank","rel":"noopener","aria-label":"twitter link"}},[_c('img',{attrs:{"src":__webpack_require__(42),"alt":"twitter logo"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.youtube,"target":"_blank","rel":"noopener","aria-label":"youtube link"}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":"youtube logo"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.pinterest,"target":"_blank","rel":"noopener","aria-label":"pinterest link"}},[_c('img',{attrs:{"src":__webpack_require__(44),"alt":"pinterest logo"}})])]),_vm._v(" "),_c('div',{staticClass:"about-links"},[_c('router-link',{attrs:{"to":{ name: 'TermsOfUse' }}},[_c('span',{staticClass:"terms",on:{"click":_vm.closePopup}},[_vm._v("TERMS OF USE")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'PrivacyPolicy' }}},[_c('span',{on:{"click":_vm.closePopup}},[_vm._v("PRIVACY POLICY")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/42.126172d55342aed007de.js